module.exports = __webpack_public_path__ + "img/group-invoice.a60fdcaa.svg";